import { render, staticRenderFns } from "./OlfChat.vue?vue&type=template&id=42499c1e&scoped=true"
import script from "./OlfChat.vue?vue&type=script&lang=js"
export * from "./OlfChat.vue?vue&type=script&lang=js"
import style0 from "./OlfChat.vue?vue&type=style&index=0&id=42499c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42499c1e",
  null
  
)

export default component.exports